import { createAsyncThunk } from '@reduxjs/toolkit';
import getStateFromThunkAPI from '../helpers/getStateFromThunkAPI';
import {
  deleteMatchEvent,
  makeMatchEvent,
  patchMatchEvent,
  postMatchEvent,
  updateMatchEvent,
} from '../../match/thunks';
import MatchEvent from '../../../interfaces/matchEvent';
import { matchSliceActions } from '../../match/matchSlice';
import lodash from 'lodash';
import { MatchEventType } from '../../../enums/matchEventType';
import generateRandomId from '../../../helpers/generateRandomId';
import isEventThatCanHaveConnectedEvent from '../../match/helpers/isEventThatCanHaveConnectedEvent';
import getActiveMatchEvent from '../helpers/getActiveMatchEvent';

const publishOrUpdateEvent = createAsyncThunk('input/publishOrUpdateEvent', async (_payload: any, thunkAPI) => {
  const { dispatch } = thunkAPI;
  const { matchState, inputState } = getStateFromThunkAPI(thunkAPI);
  const { match } = matchState;
  const activeMatchEvents = match.matchEvents.filter((matchEvent) => matchEvent.internal?.active);
  const { selects } = inputState;

  if (activeMatchEvents && !lodash.isEmpty(activeMatchEvents)) {
    let matchEvent = getActiveMatchEvent(activeMatchEvents, true);
    if (!matchEvent) {
      const matchEvents = activeMatchEvents.filter(
        (matchEvent) =>
          matchEvent.matchEventTypeId === MatchEventType.PENALTY_MISS ||
          matchEvent.matchEventTypeId === MatchEventType.PENALTIES_MISS ||
          matchEvent.matchEventTypeId === MatchEventType.PENALTIES_GOAL,
      );
      if (matchEvents) {
        matchEvent = matchEvents[0];
      }
    }
    const originalMatchEvent = lodash.cloneDeep(matchEvent);
    const person = matchEvent?.person;

    const updateResponse = await dispatch(updateMatchEvent({ matchEvent: matchEvent }));
    matchEvent = updateResponse.payload as MatchEvent;
    if (
      matchEvent &&
      (matchEvent.matchEventTypeId === MatchEventType.PENALTY_MISS ||
        matchEvent.matchEventTypeId === MatchEventType.PENALTIES_MISS ||
        matchEvent.matchEventTypeId === MatchEventType.PENALTIES_GOAL) &&
      person
    ) {
      matchEvent.person = person;
    }

    let penaltyTakerChanged = false;
    if (
      matchEvent &&
      (matchEvent.matchEventTypeId === MatchEventType.PENALTY ||
        matchEvent.matchEventTypeId === MatchEventType.PENALTIES_PENALTY) &&
      ((person && matchEvent.person && person.id !== matchEvent.person.id) ||
        (person && !matchEvent.person) ||
        (!person && matchEvent.person))
    ) {
      penaltyTakerChanged = true;
    }

    dispatch(matchSliceActions.updateEvent(matchEvent));

    let matchEvent2;
    let offenceGoalEvent;
    let penaltyGoalMatchEvent;
    let penaltyMissMatchEvent;
    let penaltySaveMatchEvent;
    let originalMatchEvent2;
    let originalOffenceGoalEvent;
    if (isEventThatCanHaveConnectedEvent(matchEvent)) {
      matchEvent2 = getActiveMatchEvent(
        activeMatchEvents,
        false,
        matchEvent.sorting,
        undefined,
        [MatchEventType.OFFENCE, MatchEventType.PENALTY_MISS, MatchEventType.PENALTY_SAVE, MatchEventType.PENALTY_GOAL],
        matchEvent.internal?.sorting,
        matchEvent.matchEventTypeId,
      );
      originalMatchEvent2 = matchEvent2 ? lodash.cloneDeep(matchEvent2) : null;
      const excludeIds: number[] = [];
      if (matchEvent2) {
        const updateResponse2 = await dispatch(
          updateMatchEvent({ matchEvent: matchEvent2, matchEventTypeId: matchEvent2.matchEventTypeId }),
        );
        matchEvent2 = updateResponse2.payload as MatchEvent;

        excludeIds.push(matchEvent2.id);
        dispatch(matchSliceActions.updateEvent(matchEvent2));
      } else {
        let matchEventTypeId2;
        switch (matchEvent.matchEventTypeId) {
          case MatchEventType.GOAL:
            matchEventTypeId2 = MatchEventType.ASSIST;
            break;
          case MatchEventType.OWN_GOAL:
            matchEventTypeId2 = MatchEventType.INDIRECT_ASSIST;
            break;
          case MatchEventType.PLAYER_OFF:
            matchEventTypeId2 = MatchEventType.PLAYER_ON;
            break;
          case MatchEventType.PENALTY:
            matchEventTypeId2 = MatchEventType.FOULED;
            break;
        }

        if (matchEventTypeId2) {
          const makeResponse = await dispatch(
            makeMatchEvent({
              matchEventTypeId: matchEventTypeId2,
              matchEvent: matchEvent,
              connectedMatchEventId: matchEvent.id,
            }),
          );
          matchEvent2 = makeResponse.payload as MatchEvent;

          if (matchEvent2) {
            dispatch(matchSliceActions.addEvent(matchEvent2));
            dispatch(
              matchSliceActions.setEventInternal({
                mainEvent: false,
                active: true,
                sorting: matchEvent.sorting,
                liveFeedSerialId: matchEvent2.liveFeedSerialId,
              }),
            );
          }
        }
      }

      offenceGoalEvent = getActiveMatchEvent(
        activeMatchEvents,
        false,
        matchEvent.sorting,
        excludeIds,
        [MatchEventType.FOULED, MatchEventType.PENALTY_MISS, MatchEventType.PENALTY_GOAL, MatchEventType.PENALTY_SAVE],
        matchEvent.internal?.sorting,
        matchEvent.matchEventTypeId,
      );
      if (offenceGoalEvent) {
        originalOffenceGoalEvent = lodash.cloneDeep(offenceGoalEvent);
        const updateResponse3 = await dispatch(
          updateMatchEvent({ matchEvent: offenceGoalEvent, matchEventTypeId: offenceGoalEvent.matchEventTypeId }),
        );
        offenceGoalEvent = updateResponse3.payload as MatchEvent;
        dispatch(matchSliceActions.updateEvent(offenceGoalEvent));
      } else {
        const makeResponse = await dispatch(
          makeMatchEvent({ matchEventTypeId: MatchEventType.OFFENCE, matchEvent: matchEvent }),
        );
        offenceGoalEvent = makeResponse.payload as MatchEvent;

        if (offenceGoalEvent) {
          dispatch(matchSliceActions.addEvent(offenceGoalEvent));
          dispatch(
            matchSliceActions.setEventInternal({
              mainEvent: false,
              active: true,
              sorting: matchEvent.sorting,
              liveFeedSerialId: offenceGoalEvent.liveFeedSerialId,
            }),
          );
        }
      }

      penaltyGoalMatchEvent = getActiveMatchEvent(activeMatchEvents, false, matchEvent.sorting, excludeIds, [
        MatchEventType.FOULED,
        MatchEventType.OFFENCE,
        MatchEventType.PENALTY_MISS,
        MatchEventType.PENALTY_SAVE,
      ]);
      if (penaltyGoalMatchEvent) {
        const updateResponse4 = await dispatch(
          updateMatchEvent({
            matchEvent: penaltyGoalMatchEvent,
            matchEventTypeId: penaltyGoalMatchEvent.matchEventTypeId,
          }),
        );
        penaltyGoalMatchEvent = updateResponse4.payload as MatchEvent;
        dispatch(matchSliceActions.updateEvent(penaltyGoalMatchEvent));
      }

      penaltyMissMatchEvent = getActiveMatchEvent(activeMatchEvents, false, matchEvent.sorting, excludeIds, [
        MatchEventType.FOULED,
        MatchEventType.OFFENCE,
        MatchEventType.PENALTY_GOAL,
        MatchEventType.PENALTY_SAVE,
      ]);
      if (penaltyMissMatchEvent && penaltyTakerChanged) {
        const updateResponse5 = await dispatch(
          updateMatchEvent({
            matchEvent: penaltyMissMatchEvent,
            matchEventTypeId: penaltyMissMatchEvent.matchEventTypeId,
            update: true,
          }),
        );
        penaltyMissMatchEvent = updateResponse5.payload as MatchEvent;
        dispatch(matchSliceActions.updateEvent(penaltyMissMatchEvent));
      }

      if (matchEvent.matchEventTypeId === MatchEventType.PENALTY_MISS) {
        penaltySaveMatchEvent = getActiveMatchEvent(activeMatchEvents, false, matchEvent.sorting, excludeIds, [
          MatchEventType.FOULED,
          MatchEventType.OFFENCE,
          MatchEventType.PENALTY_GOAL,
          MatchEventType.PENALTY_MISS,
        ]);
        if (penaltySaveMatchEvent) {
          const updateResponse5 = await dispatch(
            updateMatchEvent({
              matchEvent: penaltySaveMatchEvent,
              matchEventTypeId: penaltySaveMatchEvent.matchEventTypeId,
              update: true,
            }),
          );
          penaltySaveMatchEvent = updateResponse5.payload as MatchEvent;
          if (penaltySaveMatchEvent.person) {
            dispatch(matchSliceActions.updateEvent(penaltySaveMatchEvent));
          } else {
            dispatch(matchSliceActions.removeEvent(penaltySaveMatchEvent));
          }
        } else {
          if (selects.playerPenaltyKeeper.value) {
            const makeResponse = await dispatch(
              makeMatchEvent({
                matchEventTypeId: MatchEventType.PENALTY_SAVE,
                sorting: matchEvent.sorting,
                matchEvent: matchEvent,
              }),
            );
            penaltySaveMatchEvent = makeResponse.payload as MatchEvent;
            dispatch(matchSliceActions.addEvent(penaltySaveMatchEvent));
            dispatch(
              matchSliceActions.setEventInternal({
                mainEvent: false,
                active: true,
                sorting: matchEvent.sorting,
                liveFeedSerialId: penaltySaveMatchEvent.liveFeedSerialId,
              }),
            );
          }
        }
      }
    } else if (matchEvent.matchEventTypeId === MatchEventType.PENALTIES_PENALTY) {
      penaltyMissMatchEvent = getActiveMatchEvent(
        activeMatchEvents,
        false,
        matchEvent.sorting,
        [],
        [MatchEventType.PENALTIES_GOAL, MatchEventType.PENALTY_SAVE],
      );
      if (penaltyMissMatchEvent && penaltyTakerChanged) {
        const updateResponse = await dispatch(
          updateMatchEvent({
            matchEvent: penaltyMissMatchEvent,
            matchEventTypeId: penaltyMissMatchEvent.matchEventTypeId,
            update: true,
          }),
        );
        penaltyMissMatchEvent = updateResponse.payload as MatchEvent;
        dispatch(matchSliceActions.updateEvent(penaltyMissMatchEvent));
      } else {
        penaltyGoalMatchEvent = getActiveMatchEvent(
          activeMatchEvents,
          false,
          matchEvent.sorting,
          [],
          [MatchEventType.PENALTIES_MISS, MatchEventType.PENALTY_SAVE],
        );
        if (penaltyGoalMatchEvent && penaltyTakerChanged) {
          const updateResponse = await dispatch(
            updateMatchEvent({
              matchEvent: penaltyGoalMatchEvent,
              matchEventTypeId: penaltyGoalMatchEvent.matchEventTypeId,
              update: true,
            }),
          );
          penaltyGoalMatchEvent = updateResponse.payload as MatchEvent;
          dispatch(matchSliceActions.updateEvent(penaltyGoalMatchEvent));
        }
      }
    } else if (matchEvent.matchEventTypeId === MatchEventType.PENALTIES_MISS) {
      penaltySaveMatchEvent = getActiveMatchEvent(
        activeMatchEvents,
        false,
        matchEvent.sorting,
        [],
        [MatchEventType.PENALTIES_GOAL, MatchEventType.PENALTIES_MISS],
      );
      if (penaltySaveMatchEvent) {
        const updateResponse = await dispatch(
          updateMatchEvent({
            matchEvent: penaltySaveMatchEvent,
            matchEventTypeId: penaltySaveMatchEvent.matchEventTypeId,
            update: true,
          }),
        );
        penaltySaveMatchEvent = updateResponse.payload as MatchEvent;
        if (penaltySaveMatchEvent.person) {
          dispatch(matchSliceActions.updateEvent(penaltySaveMatchEvent));
        } else {
          dispatch(matchSliceActions.removeEvent(penaltySaveMatchEvent));
        }
      } else {
        if (selects.playerPenaltyKeeper.value) {
          const makeResponse = await dispatch(
            makeMatchEvent({
              matchEventTypeId: MatchEventType.PENALTY_SAVE,
              sorting: matchEvent.sorting,
              matchEvent: matchEvent,
            }),
          );
          penaltySaveMatchEvent = makeResponse.payload as MatchEvent;
          dispatch(matchSliceActions.addEvent(penaltySaveMatchEvent));
          dispatch(
            matchSliceActions.setEventInternal({
              mainEvent: false,
              active: true,
              sorting: matchEvent.sorting,
              liveFeedSerialId: penaltySaveMatchEvent.liveFeedSerialId,
            }),
          );
        }
      }
    }

    try {
      if (matchEvent.id) {
        dispatch(patchMatchEvent(matchEvent));
      } else {
        if (!lodash.isEqual(originalMatchEvent, matchEvent)) {
          dispatch(postMatchEvent(matchEvent));
        }
      }

      if (matchEvent2 && matchEvent2.id) {
        if (!matchEvent2.person) {
          dispatch(deleteMatchEvent(matchEvent2));
        } else {
          dispatch(patchMatchEvent(matchEvent2));
        }
      } else if (matchEvent2) {
        if (!lodash.isEqual(originalMatchEvent2, matchEvent2)) {
          postConnectedEvent(matchEvent2, dispatch);
        }
      }

      if (offenceGoalEvent && offenceGoalEvent.id) {
        if (!offenceGoalEvent.person) {
          dispatch(deleteMatchEvent(offenceGoalEvent));
        } else {
          dispatch(patchMatchEvent(offenceGoalEvent));
        }
      } else if (offenceGoalEvent) {
        if (!lodash.isEqual(originalOffenceGoalEvent, offenceGoalEvent)) {
          postConnectedEvent(offenceGoalEvent, dispatch);
        }
      }

      if (penaltyGoalMatchEvent && penaltyGoalMatchEvent.id) {
        dispatch(patchMatchEvent(penaltyGoalMatchEvent));
      }

      if (penaltySaveMatchEvent && penaltySaveMatchEvent.id) {
        if (penaltySaveMatchEvent.person) {
          dispatch(patchMatchEvent(penaltySaveMatchEvent));
        } else {
          dispatch(deleteMatchEvent(penaltySaveMatchEvent));
        }
      } else if (penaltySaveMatchEvent) {
        dispatch(postMatchEvent(penaltySaveMatchEvent));
      }

      if (penaltyMissMatchEvent && penaltyMissMatchEvent.id) {
        dispatch(patchMatchEvent(penaltyMissMatchEvent));
      }
    } catch (e) {
      throw e;
    }
  } else {
    const makeResponse = await dispatch(makeMatchEvent({}));
    const matchEvent = makeResponse.payload as MatchEvent;

    const sorting = generateRandomId([]);
    dispatch(matchSliceActions.addEvent(matchEvent));
    dispatch(
      matchSliceActions.setEventInternal({
        mainEvent: true,
        active: true,
        sorting: sorting,
        liveFeedSerialId: matchEvent.liveFeedSerialId,
      }),
    );

    let matchEvent2;
    let matchEvent3;
    if (isEventThatCanHaveConnectedEvent(matchEvent)) {
      let matchEventTypeId;
      switch (matchEvent.matchEventTypeId) {
        case MatchEventType.GOAL:
          matchEventTypeId = MatchEventType.ASSIST;
          break;
        case MatchEventType.OWN_GOAL:
          matchEventTypeId = MatchEventType.INDIRECT_ASSIST;
          break;
        case MatchEventType.PLAYER_OFF:
          matchEventTypeId = MatchEventType.PLAYER_ON;
          break;
        case MatchEventType.PENALTY:
          matchEventTypeId = MatchEventType.FOULED;
          break;
      }

      const makeResponse = await dispatch(
        makeMatchEvent({
          matchEventTypeId: matchEventTypeId,
          matchEvent: matchEvent,
          connectedMatchEventId: matchEvent.id,
        }),
      );
      matchEvent2 = makeResponse.payload as MatchEvent;

      if (matchEvent2) {
        dispatch(matchSliceActions.addEvent(matchEvent2));
        dispatch(
          matchSliceActions.setEventInternal({
            mainEvent: false,
            active: true,
            sorting: sorting,
            liveFeedSerialId: matchEvent2.liveFeedSerialId,
          }),
        );
      }

      if (matchEvent.matchEventTypeId === MatchEventType.PENALTY) {
        const makeResponse = await dispatch(
          makeMatchEvent({ matchEventTypeId: MatchEventType.OFFENCE, matchEvent: matchEvent }),
        );
        matchEvent3 = makeResponse.payload as MatchEvent;

        if (matchEvent3) {
          dispatch(matchSliceActions.addEvent(matchEvent3));
          dispatch(
            matchSliceActions.setEventInternal({
              mainEvent: false,
              active: true,
              sorting: sorting,
              liveFeedSerialId: matchEvent3.liveFeedSerialId,
            }),
          );
        }
      }
    }

    try {
      //Need to post the main match event before posting any connected events
      await dispatch(postMatchEvent(matchEvent));

      postConnectedEvent(matchEvent2, dispatch);
      postConnectedEvent(matchEvent3, dispatch);
    } catch (e) {
      throw e;
    }
  }
});

function postConnectedEvent(matchEvent: MatchEvent, dispatch) {
  if (matchEvent) {
    dispatch(postMatchEvent(matchEvent));
  }
}

export default publishOrUpdateEvent;
